const TAG = 'USER_'
export const RESET_STORE_USER = 'RESET_STORE_USER';

export const GET_CONSOLIDATED_REQUEST = 'GET_CONSOLIDATED_REQUEST';
export const GET_CONSOLIDATED_SUCCESS = 'GET_CONSOLIDATED_SUCCESS';
export const GET_CONSOLIDATED_ERROR = 'GET_CONSOLIDATED_ERROR';

export const GET_ENERGY_CONSUMPTION_REQUEST = 'GET_ENERGY_CONSUMPTION_REQUEST';
export const GET_ENERGY_CONSUMPTION_SUCCESS = 'GET_ENERGY_CONSUMPTION_SUCCESS';
export const GET_ENERGY_CONSUMPTION_ERROR = 'GET_ENERGY_CONSUMPTION_ERROR';

export const GET_NETWORK_ENERGY_CONSUMPTION_REQUEST = 'GET_NETWORK_ENERGY_CONSUMPTION_REQUEST';
export const GET_NETWORK_ENERGY_CONSUMPTION_SUCCESS = 'GET_NETWORK_ENERGY_CONSUMPTION_SUCCESS';
export const GET_NETWORK_ENERGY_CONSUMPTION_ERROR = 'GET_NETWORK_ENERGY_CONSUMPTION_ERROR';

export const GET_OPERATIONAL_EFFICIENCY_REQUEST = 'GET_OPERATIONAL_EFFICIENCY_REQUEST';
export const GET_OPERATIONAL_EFFICIENCY_SUCCESS = 'GET_OPERATIONAL_EFFICIENCY_SUCCESS';
export const GET_OPERATIONAL_EFFICIENCY_ERROR = 'GET_OPERATIONAL_EFFICIENCY_ERROR';

export const GET_PREDICTION_FAULT_REQUEST = 'GET_PREDICTION_FAULT_REQUEST';
export const GET_PREDICTION_FAULT_SUCCESS = 'GET_PREDICTION_FAULT_SUCCESS';
export const GET_PREDICTION_FAULT_ERROR = 'GET_PREDICTION_FAULT_ERROR';

export const GET_INSIGHTS_REQUEST = 'GET_INSIGHTS_REQUEST';
export const GET_INSIGHTS_SUCCESS = 'GET_INSIGHTS_SUCCESS';
export const GET_INSIGHTS_ERROR = 'GET_INSIGHTS_ERROR';


